<div class="flex flex-col gap-5">
    <ul role="list" class="grid grid-cols-1 gap-3 sm:grid-cols-2">
        @for (method of methods; track method.id) {
        <li>
            <button type="button" (click)="selectMethod(method.id)"
                [attr.aria-pressed]="selectedMethod() === method.id"
                class="relative flex h-full w-full items-start gap-3.5 rounded-xl border-[1.5px] p-5 text-left transition-all"
                [class]="selectedMethod() === method.id ? 'border-brand-studio bg-brand-studio/10 ring-2 ring-brand-studio/25' : 'border-border bg-card hover:border-foreground/30 hover:shadow-sm'">
                <span class="grid size-10 shrink-0 place-items-center rounded-md transition-colors"
                    [class]="selectedMethod() === method.id ? 'bg-brand-studio text-white' : 'bg-muted text-muted-foreground'">
                    @switch (method.id) {
                    @case ('one') {
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        aria-hidden="true">
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                        <circle cx="9" cy="7" r="4" />
                        <line x1="19" x2="19" y1="8" y2="14" />
                        <line x1="22" x2="16" y1="11" y2="11" />
                    </svg>
                    }
                    @case ('csv') {
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        aria-hidden="true">
                        <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
                        <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                        <path d="M8 13h2" />
                        <path d="M14 13h2" />
                        <path d="M8 17h2" />
                        <path d="M14 17h2" />
                    </svg>
                    }
                    @case ('shout') {
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        aria-hidden="true">
                        <path d="M18 21a8 8 0 0 0-16 0" />
                        <circle cx="10" cy="8" r="5" />
                        <path d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3" />
                    </svg>
                    }
                    @case ('later') {
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        aria-hidden="true">
                        <path d="M12 6v6l4 2" />
                        <circle cx="12" cy="12" r="10" />
                    </svg>
                    }
                    }
                </span>
                <span class="min-w-0">
                    <span class="block font-heading text-base font-bold leading-tight text-foreground">{{ method.name
                        }}</span>
                    <span class="mt-1 block text-[12.5px] leading-relaxed text-muted-foreground">{{ method.description
                        }}</span>
                </span>
            </button>
        </li>
        }
    </ul>

    @if (hasPreselectedCreators() && selectedMethod() === 'shout') {
    <div class="flex flex-col gap-3">
        <div class="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
            <div>
                <h3 class="m-0 text-base font-semibold text-foreground">
                    These creators will be screened
                </h3>
                <p class="m-0 mt-1 text-sm text-muted-foreground">
                    We'll check their existing Instagram and TikTok posts against your rules when you launch.
                </p>
            </div>
            <p class="m-0 shrink-0 rounded-full bg-brand-studio px-3 py-1 text-xs font-semibold text-white">
                {{ selectedCreatorCount() }}
                {{ selectedCreatorCount() === 1 ? 'creator' : 'creators' }}
            </p>
        </div>

        <ul role="list" class="flex flex-col gap-2">
            @for (creator of socialScreeningService.selectedCreators(); track creator.blazeFirebaseUid) {
            <li class="flex items-center gap-3 rounded-lg border border-border bg-card p-3">
                <div class="size-12 shrink-0 overflow-hidden rounded-full bg-muted">
                    <atom-ldg-img inputClass="object-cover" w="full" radius="full"
                        [src]="imageService.getImageSource(creator.photoURL, 'gallery_xl')"></atom-ldg-img>
                </div>
                <div class="min-w-0 flex-1">
                    <p class="m-0 truncate text-sm font-semibold text-foreground">{{ creatorDisplayName(creator) }}</p>
                    @let igHandle = instagramHandle(creator);
                    @let ttHandle = tiktokHandle(creator);
                    @let igFollowers = instagramFollowersLabel(creator);
                    @let ttFollowers = tiktokFollowersLabel(creator);
                    <div class="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1">
                        @if (igHandle) {
                        <p class="m-0 flex items-center gap-1 text-xs text-muted-foreground">
                            <span class="font-medium text-foreground/80">IG</span>
                            <span>@{{ igHandle }}</span>
                            @if (igFollowers) {
                            <span>· {{ igFollowers }}</span>
                            }
                        </p>
                        }
                        @if (ttHandle) {
                        <p class="m-0 flex items-center gap-1 text-xs text-muted-foreground">
                            <span class="font-medium text-foreground/80">TT</span>
                            <span>@{{ ttHandle }}</span>
                            @if (ttFollowers) {
                            <span>· {{ ttFollowers }}</span>
                            }
                        </p>
                        }
                        @if (!canScreenCreator(creator)) {
                        <p class="m-0 text-xs text-red-600">Hasn't got an Instagram or TikTok handle — can't be
                            screened.</p>
                        }
                    </div>
                </div>
                <button type="button" (click)="removeSelectedCreator(creator)"
                    class="inline-flex items-center gap-1 rounded-md px-2 py-1 text-xs font-medium text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
                    [attr.aria-label]="'Remove ' + creatorDisplayName(creator) + ' from this screening'">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-4" aria-hidden="true">
                        <path d="M18 6 6 18" />
                        <path d="m6 6 12 12" />
                    </svg>
                    <span class="hidden sm:inline">Remove</span>
                </button>
            </li>
            }
        </ul>
    </div>
    }

    @switch (selectedMethod()) {
    @case ('later') {
    <div class="flex items-start gap-3 rounded-xl border border-border bg-muted p-5">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="mt-0.5 shrink-0 text-brand-studio-dark dark:text-brand-studio" aria-hidden="true">
            <path d="M12 6v6l4 2" />
            <circle cx="12" cy="12" r="10" />
        </svg>
        <div>
            <p class="m-0 font-heading text-base font-bold text-foreground">Add creators whenever you're ready</p>
            <p class="m-0 mt-1 text-[13px] leading-relaxed text-muted-foreground">Your brief will be saved and ready.
                Open it from Manage Brief to add creators and start screening at any time.</p>
        </div>
    </div>
    }
    @case ('one') {
    <div class="flex flex-col gap-4">
        <div class="rounded-lg border border-border bg-card p-3.5">
            <div class="flex flex-col gap-4">
                <div>
                    <label for="creator-list-name" class="block text-md font-semibold text-foreground/80">List
                        name</label>
                    <div class="mt-2">
                        <input [formField]="creatorListForm.listName" id="creator-list-name" type="text"
                            placeholder="Creator list name" class="input-primary text-primary" />
                        @if (creatorListForm.listName().touched() &&
                        creatorListForm.listName().invalid()) {
                        <ul class="error-list">
                            @for (error of creatorListForm.listName().errors(); track error) {
                            <li class="text-error-light flex items-start gap-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                    stroke-linejoin="round" class="shrink-0 mt-0.5" aria-hidden="true">
                                    <path
                                        d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                                    <path d="M12 9v4" />
                                    <path d="M12 17h.01" />
                                </svg>
                                {{ error.message }}
                            </li>
                            }
                        </ul>
                        }
                    </div>
                </div>

                <div>
                    <label for="creator-list-description" class="block text-md font-semibold text-foreground/80">List
                        description</label>
                    <div class="mt-2">
                        <textarea [formField]="creatorListForm.listDescription" id="creator-list-description" rows="2"
                            class="input-textarea text-primary"></textarea>
                    </div>
                    <p class="mt-1 text-xs text-muted-foreground">Write a few sentences about the list of creators.</p>
                </div>
            </div>
        </div>

        <div class="rounded-lg border border-border bg-card p-3.5">
            <div class="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div>
                    <h3 class="font-heading text-md font-bold leading-none tracking-tight">Creators</h3>
                    <p class="mt-1 text-sm text-muted-foreground">Add creators to your screening list</p>
                </div>
                <button (click)="addCreatorRow()" type="button"
                    class="btn-shout btn-shout-xs btn-shout-primary inline-flex items-center gap-x-1.5 self-start">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-4">
                        <path d="M5 12h14" />
                        <path d="M12 5v14" />
                    </svg>
                    Add Row
                </button>
            </div>
            <div class="overflow-x-auto rounded-lg border border-border">
                <table class="min-w-full divide-y divide-border">
                    <thead class="bg-muted/50">
                        <tr>
                            <th scope="col"
                                class="py-3 pr-3 pl-4 text-left text-xs font-semibold text-foreground sm:pl-6">
                                Creator Name</th>
                            <th scope="col" class="px-3 py-3 text-left text-xs font-semibold text-foreground">
                                Instagram Handle</th>
                            <th scope="col" class="px-3 py-3 text-left text-xs font-semibold text-foreground">TikTok
                                Handle</th>
                            <th scope="col"
                                class="py-3 pr-4 pl-3 text-right text-xs font-semibold text-foreground sm:pr-6">
                                Actions</th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-border bg-card">
                        @for (creator of creators(); track $index) {
                        <tr>
                            <td class="py-3 pr-3 pl-4 text-sm sm:pl-6">
                                <input type="text" [value]="creator.creatorName"
                                    (input)="updateCreatorField($index, 'creatorName', $any($event.target).value)"
                                    placeholder="Creator name" class="input-primary w-full text-sm text-primary" />
                            </td>
                            <td class="px-3 py-3 text-sm">
                                <input type="text" [value]="creator.instagram"
                                    (input)="updateCreatorField($index, 'instagram', $any($event.target).value)"
                                    placeholder="@handle or handle" class="input-primary w-full text-sm text-primary" />
                            </td>
                            <td class="px-3 py-3 text-sm">
                                <input type="text" [value]="creator.tiktok"
                                    (input)="updateCreatorField($index, 'tiktok', $any($event.target).value)"
                                    placeholder="@handle or handle" class="input-primary w-full text-sm text-primary" />
                            </td>
                            <td class="py-3 pr-4 pl-3 text-right text-sm font-medium sm:pr-6">
                                <button (click)="removeCreatorRow($index)" type="button"
                                    class="fab-button-delete inline-flex size-8 items-center justify-center"
                                    aria-label="Remove creator row">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-4">
                                        <path d="M3 6h18" />
                                        <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                                        <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                                    </svg>
                                </button>
                            </td>
                        </tr>
                        } @empty {
                        <tr>
                            <td colspan="4" class="py-8 text-center text-sm text-muted-foreground">
                                No creators added yet. Click "Add Row" to get started.
                            </td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    }
    @case ('csv') {
    <div class="flex flex-col gap-4">
        <div class="rounded-lg border border-border bg-card p-3.5">
            <div class="w-full flex flex-row items-center justify-between">
                <div>
                    <h3 class="font-heading text-md font-bold leading-none tracking-tight">Excel file format</h3>
                    <p class="mt-1 text-sm text-muted-foreground">Upload an Excel file (or CSV) with creator
                        information.</p>
                </div>
                <button type="button" (click)="getTemplate($event)"
                    class="btn-shout btn-shout-xs btn-shout-primary inline-flex items-center gap-x-2 transition-all ease-in-out duration-300">
                    Get Template
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-5 transition-transform duration-300 ease-in-out group-hover:translate-x-1">
                        <path d="M12 13v8l-4-4" />
                        <path d="m12 21 4-4" />
                        <path d="M4.393 15.269A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.436 8.284" />
                    </svg>
                </button>
            </div>


            <div class="mt-4 overflow-x-auto rounded-lg border border-border">
                <table class="min-w-full divide-y divide-border">
                    <thead class="bg-muted/50">
                        <tr>
                            <th scope="col"
                                class="py-3 pr-3 pl-4 text-left text-xs font-semibold text-foreground sm:pl-6">
                                Creator Name</th>
                            <th scope="col" class="px-3 py-3 text-left text-xs font-semibold text-foreground">
                                Instagram Handle</th>
                            <th scope="col" class="px-3 py-3 text-left text-xs font-semibold text-foreground">TikTok
                                Handle</th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-border bg-card">
                        <tr>
                            <td class="py-3 pr-3 pl-4 text-sm font-medium text-foreground sm:pl-6">Creator Name</td>
                            <td class="px-3 py-3 text-sm text-muted-foreground">&#64;handle or handle</td>
                            <td class="px-3 py-3 text-sm text-muted-foreground">&#64;handle or handle</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="rounded-lg border border-border bg-card p-3.5">
            <label for="creator-csv-upload" class="block text-md font-semibold text-foreground/80">Upload creator
                file</label>
            <div class="mt-3 w-full overflow-hidden">
                <atom-add-document (documentUploaded)="onDocumentUploaded($event)"></atom-add-document>
            </div>
        </div>

        <div>
            <label for="google-doc-url" class="block text-md font-semibold text-foreground/80">Or paste a Google Doc
                URL</label>
            <div class="mt-2">
                <input [formField]="creatorListForm.googleDocUrl" id="google-doc-url" type="text"
                    placeholder="https://docs.google.com/document/d/1234567890/edit"
                    class="input-primary text-primary" />
                <p class="mt-1 text-xs text-muted-foreground">Make sure your Google Doc is publicly accessible or shared
                    with view permissions.</p>
            </div>
        </div>
    </div>
    }
    @case ('shout') {
    <div class="flex flex-col gap-2.5">
        @if (allLists() && allLists().length > 0) {
        @for (list of allLists(); track list.id) {
        <button type="button" (click)="selectList(list)"
            class="flex w-full items-center gap-3.5 rounded-lg border p-3.5 text-left transition-colors"
            [class]="createScreeningService.selectedList()?.id === list.id ? 'border-2 border-brand-studio bg-brand-studio/[0.06] ring-2 ring-brand-studio/20' : 'border-border bg-card hover:border-foreground/30'">
            <div class="grid size-10 shrink-0 place-items-center rounded-md bg-muted text-muted-foreground">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
            </div>
            <div class="min-w-0 flex-1">
                <div class="font-heading text-base font-bold leading-tight">{{ list.groupName }}</div>
                <p class="mt-1 text-xs text-muted-foreground">
                    {{ list.numberOfCreators || 0 }} {{ (list.numberOfCreators || 0) === 1 ? 'creator' : 'creators' }}
                    @if (list.groupDescription) {
                    · {{ list.groupDescription }}
                    }
                </p>
                <p class="mt-1 text-xs text-muted-foreground">{{ list.createdDate | date:'dd/MM/yyyy' }}</p>
            </div>
            @if (createScreeningService.selectedList()?.id === list.id) {
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="size-5 shrink-0 text-brand-studio" aria-hidden="true">
                <path d="M20 6 9 17l-5-5" />
            </svg>
            }
        </button>
        }
        } @else {
        <div class="flex items-center justify-center rounded-lg border border-border bg-card p-8">
            <div class="text-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                    class="mx-auto size-12 text-muted-foreground" aria-hidden="true">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
                <h3 class="mt-4 font-heading text-md font-bold leading-none tracking-tight">No creator lists yet</h3>
                <p class="mt-2 text-sm text-muted-foreground">Get started by creating your first creator list.</p>
            </div>
        </div>
        }
    </div>
    }
    }

    @if (selectedMethod() === 'later') {
    <p class="m-0 inline-flex items-center gap-2 self-start rounded-full bg-brand-studio/10 px-3.5 py-2 text-[13px] font-semibold text-brand-studio-dark dark:text-brand-studio">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M20 6 9 17l-5-5" />
        </svg>
        You can add creators after submitting.
    </p>
    } @else if (tally()) {
    <p class="m-0 inline-flex items-center gap-2 self-start rounded-full bg-brand-studio/10 px-3.5 py-2 text-[13px] font-semibold text-brand-studio-dark dark:text-brand-studio">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M20 6 9 17l-5-5" />
        </svg>
        {{ tally() }} {{ tally() === 1 ? 'creator' : 'creators' }} ready to screen
    </p>
    }

</div>